module.exports = __webpack_public_path__ + "static/media/loveseat.ba176175.svg";